import styled, { css } from 'styled-components';
import { Link } from 'react-router';
import { contentWidthMedia } from '../../../styled/utils';
import FlexWrapper from '../../../ui/FlexWrapper';
import { contentBreakpoints } from '../../../constants/breakpoints';

export const CampaignLinkContainer = styled(FlexWrapper).attrs({
    as: Link,
})`
    flex-direction: column;
    overflow: hidden;
    text-decoration: none;
    padding: 0;
    color: #2a2a2a;
    cursor: pointer;
`;

export const CampaignImage = styled.img`
    display: block;
    width: 100%;
    height: 198px;
    object-fit: cover;
    object-position: center;
    border-radius: 4px 4px 0 0;
    flex-shrink: 0;
    flex-grow: 0;

    ${({ $contentWidth }) => {
        const media = contentWidthMedia($contentWidth);

        return css`
            ${media.lessThan(
                contentBreakpoints.SM,
                css`
                    height: 267px;
                `
            )};
            ${media.lessThan(
                contentBreakpoints.XS,
                css`
                    height: 217px;
                `
            )};
        `;
    }};
`;

export const TextContentBlock = styled(FlexWrapper)`
    flex-grow: 1;
    justify-content: flex-start;
    gap: 12px;
    width: 100%;
    padding: 24px 36px;
    box-sizing: border-box;
    background-color: ${({ theme }) => theme.bg.secondaryWhite};
    border-radius: 0 0 4px 4px;
    border: 1px solid ${({ theme }) => theme.borders.neutralBorder};
    border-top: none;

    h3 {
        margin: 0;
        font-size: 20px;
        font-weight: 700;
        line-height: 32px;
    }

    p {
        margin: 0;
    }
`;

export const CampaignTeaser = styled.div`
    font-size: 13px;
    font-weight: 400;
    line-height: 20px;
`;

export const Rules = styled.div`
    width: 100%;
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.text.neutralDarkSemiGrey};
    border-top: 1px solid ${({ theme }) => theme.borders.secondaryOutline};
    padding-top: 12px;
`;
